var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAeroplanemoM2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2018_\\xEB\\xEE\\xE9_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3200 2000",
    style: {
      enableBackground: "new 0 0 3200 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E58638;}\r\n\t.st1{fill:#AFCDFB;}\r\n\t.st2{fill:#739AF0;}\r\n\t.st3{fill:#699FF0;}\r\n\t.st4{fill:#2B478B;}\r\n\t.st5{fill:#D86713;}\r\n\t.st6{opacity:0.6;fill:#D2E4FF;enable-background:new    ;}\r\n\t.st7{opacity:0.7;fill:#F8FBFF;enable-background:new    ;}\r\n\t.st8{opacity:0.2;fill:#F8FBFF;enable-background:new    ;}\r\n\t.st9{opacity:0.1;fill:#4A75CB;enable-background:new    ;}\r\n\t.st10{fill:#D4E4F8;}\r\n\t.st11{fill:#9FC3F7;}\r\n\t.st12{fill:#899DC5;}\r\n\t.st13{fill:#EE9849;}\r\n\t.st14{fill:#F1A34F;}\r\n\t.st15{opacity:0.4;fill:#D86713;enable-background:new    ;}\r\n\t.st16{fill:#163560;}\r\n\t.st17{fill:#F9DDBF;}\r\n\t.st18{fill:#8DBC84;}\r\n\t.st19{fill:#A8D29F;}\r\n\t.st20{opacity:0.7;fill:#82B378;enable-background:new    ;}\r\n\t.st21{fill:#E9F3FE;}\r\n\t.st22{opacity:0.5;fill:#82B378;enable-background:new    ;}\r\n\t.st23{fill:#ED7D2B;}\r\n\t.st24{fill:#1C468A;}\r\n\t.st25{fill:#FFB27D;}\r\n\t.st26{fill:#F99746;}\r\n\t.st27{fill:#FCA56B;}\r\n\t.st28{fill:#0E2C4F;}\r\n\t.st29{fill:#EAC3A2;}\r\n\t.st30{fill:#EAA16E;}\r\n\t.st31{fill:#77A4E5;}\r\n\t.st32{fill:#CC6A27;}\r\n\t.st33{fill:#3C5EA5;}\r\n\t.st34{fill:#2E3552;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2201.7,573.6l-59.4,136.7l-1.6-0.3l-177.2-37.1c0,0,83.2-4.3,92.1-11.1c8.4-6.5,98.5-84.2,124.1-90.7 c1.6-0.4,2.9-0.5,3.9-0.4C2201.7,573.6,2201.7,573.6,2201.7,573.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2147.8,738.9c-4.1,0.6-16.5,2.3-33.5,4.3c-48.8,5.6-135.4,13.8-173.2,7.3c-33.8-5.8-212.9-36.8-336.6-59.3 c32.2-38.3,70.8-57.1,105.7-65.8c144.2,25.6,332.8,59.5,356.7,65.9c39.3,10.5,91.6,21.3,91.6,21.3s0.3,1.3,0.5,3.4 C2159.9,722.6,2160.1,737,2147.8,738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2147.8,738.9c-4.1,0.6-16.5,2.3-33.5,4.3c-48.8,5.6-135.4,13.8-173.2,7.3c-33.8-5.8-212.9-36.8-336.6-59.3 c-62.1-11.3-110.4-20.5-119.3-23.3c-26.6-8.4-81.3-34-74.4-45.6c6.9-11.6,28.8-11.3,35.6-15.3c0.1-0.1,0.2-0.1,0.3-0.2 c1.6-0.9,4.2-2.5,7.9-4.2c13.3-6.2,41.1-14.9,88-6.9c0,0,74.6,13.1,167.6,29.6c144.2,25.6,332.8,59.5,356.7,65.9 c39.3,10.5,91.6,21.3,91.6,21.3s0.3,1.3,0.5,3.4C2159.9,722.6,2160.1,737,2147.8,738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2147.8,738.9c-4.1,0.6-16.5,2.3-33.5,4.3c-4.7-19.1-22.3-28.9-22.3-28.9l67.1,1.6 C2159.9,722.6,2160.1,737,2147.8,738.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1993.4,710.5L1993.4,710.5c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1995.5,710,1994.5,710.7,1993.4,710.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1983,708.7L1983,708.7c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1985.1,708.1,1984.1,708.9,1983,708.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1972.6,706.8L1972.6,706.8c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1974.7,706.2,1973.7,707,1972.6,706.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1962.2,704.9L1962.2,704.9c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1964.3,704.3,1963.3,705.1,1962.2,704.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1951.8,703L1951.8,703c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1953.9,702.4,1952.9,703.2,1951.8,703z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1941.4,701.1L1941.4,701.1c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1943.5,700.6,1942.5,701.3,1941.4,701.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1931,699.2L1931,699.2c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1933.1,698.7,1932.1,699.4,1931,699.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1920.6,697.4L1920.6,697.4c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1922.7,696.8,1921.7,697.6,1920.6,697.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1910.1,695.5L1910.1,695.5c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1912.3,694.9,1911.3,695.7,1910.1,695.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1787.6,673.3L1787.6,673.3c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1789.7,672.7,1788.7,673.5,1787.6,673.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1777.2,671.4L1777.2,671.4c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1779.3,670.9,1778.3,671.6,1777.2,671.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1766.8,669.6L1766.8,669.6c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1768.9,669,1767.9,669.8,1766.8,669.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1756.4,667.7L1756.4,667.7c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1758.5,667.1,1757.5,667.9,1756.4,667.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1746,665.8L1746,665.8c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1748.1,665.2,1747.1,666,1746,665.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1735.6,663.9L1735.6,663.9c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1737.7,663.3,1736.7,664.1,1735.6,663.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1725.2,662L1725.2,662c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1727.3,661.4,1726.3,662.2,1725.2,662z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1714.8,660.1L1714.8,660.1c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1716.9,659.6,1715.9,660.3,1714.8,660.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1704.4,658.3L1704.4,658.3c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1706.5,657.7,1705.5,658.5,1704.4,658.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1664.1,651L1664.1,651c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1666.3,650.4,1665.2,651.2,1664.1,651z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1684.4,654.7L1684.4,654.7c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1686.6,654.1,1685.6,654.9,1684.4,654.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1653.7,649.1L1653.7,649.1c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1655.9,648.5,1654.8,649.3,1653.7,649.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1643.3,647.2L1643.3,647.2c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1645.5,646.6,1644.4,647.4,1643.3,647.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1632.9,645.3L1632.9,645.3c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1635.1,644.8,1634,645.5,1632.9,645.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1622.5,643.5L1622.5,643.5c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1624.7,642.9,1623.6,643.7,1622.5,643.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1612.1,641.6L1612.1,641.6c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1614.3,641,1613.2,641.8,1612.1,641.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1601.7,639.7L1601.7,639.7c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1603.9,639.1,1602.8,639.9,1601.7,639.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1591.3,637.8L1591.3,637.8c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1593.5,637.2,1592.4,638,1591.3,637.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1580.9,635.9L1580.9,635.9c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1583.1,635.3,1582,636.1,1580.9,635.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1570.7,634.1L1570.7,634.1c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1572.9,633.5,1571.8,634.3,1570.7,634.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1560.3,632.2L1560.3,632.2c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1562.5,631.6,1561.4,632.4,1560.3,632.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1549.9,630.3L1549.9,630.3c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1552.1,629.7,1551,630.5,1549.9,630.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1468,610.5c-0.4,1.4-1.6,2.2-2.9,2.3c-0.3,0-0.7,0-1-0.1l-17.3-5.7c1.6-0.9,4.2-2.5,7.9-4.2l11.3,3.7 C1467.6,606.9,1468.5,608.7,1468,610.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1736.2,673.9c-0.2,0-0.5,0-0.7-0.1l-3.2-0.6c-1.1-0.2-2-0.8-2.6-1.7c-0.6-0.9-0.9-2-0.7-3.1l2.3-13.7 c0.3-2,2-3.5,4-3.5c0.2,0,0.5,0,0.7,0.1l3.2,0.6c2.2,0.4,3.6,2.6,3.3,4.8l-2.3,13.7C1739.8,672.4,1738.1,673.9,1736.2,673.9z  M1735.3,651.6c-1.8,0-3.3,1.3-3.6,3.2l-2.3,13.7c-0.2,1,0.1,2,0.6,2.9c0.6,0.8,1.4,1.4,2.4,1.6l3.2,0.6c0.2,0,0.4,0.1,0.6,0.1 c1.8,0,3.3-1.3,3.6-3.2l2.3-13.7c0.4-2.1-1-4.1-3-4.4l-3.2-0.6C1735.7,651.6,1735.5,651.6,1735.3,651.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1756.8,677.6c-0.2,0-0.5,0-0.7-0.1l-3.2-0.6c-2.2-0.4-3.6-2.6-3.3-4.8l2.3-13.7c0.3-2,2-3.5,4-3.5 c0.2,0,0.5,0,0.7,0.1l3.2,0.6c1.1,0.2,2,0.8,2.6,1.7c0.6,0.9,0.9,2,0.7,3.1l-2.3,13.7C1760.5,676.2,1758.8,677.6,1756.8,677.6z  M1756,655.3c-1.8,0-3.3,1.3-3.6,3.2l-2.3,13.7c-0.4,2.1,1,4.1,3,4.4l3.2,0.6c0.2,0,0.4,0.1,0.6,0.1c1.8,0,3.3-1.3,3.6-3.2 l2.3-13.7c0.2-1-0.1-2-0.6-2.9c-0.6-0.8-1.4-1.4-2.4-1.6l-3.2-0.6C1756.4,655.3,1756.2,655.3,1756,655.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1879.6,690L1879.6,690c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1881.7,689.4,1880.7,690.2,1879.6,690z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1869.2,688.1L1869.2,688.1c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1871.3,687.5,1870.3,688.3,1869.2,688.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1858.8,686.2L1858.8,686.2c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1860.9,685.6,1859.9,686.4,1858.8,686.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1848.4,684.3L1848.4,684.3c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1850.5,683.7,1849.5,684.5,1848.4,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1838,682.4L1838,682.4c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1840.1,681.9,1839.1,682.6,1838,682.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1827.6,680.5L1827.6,680.5c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1829.7,680,1828.7,680.7,1827.6,680.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1817.2,678.7L1817.2,678.7c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1819.3,678.1,1818.3,678.9,1817.2,678.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1806.8,676.8L1806.8,676.8c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1808.9,676.2,1807.9,677,1806.8,676.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1796.3,674.9L1796.3,674.9c-1.1-0.2-1.9-1.3-1.7-2.5l0.4-2.2c0.2-1.2,1.3-1.9,2.4-1.7l0,0 c1.1,0.2,1.9,1.3,1.7,2.5l-0.4,2.2C1798.5,674.3,1797.5,675.1,1796.3,674.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1753,720.2c6.1-1.2,8.1-9.3,3.3-13.4s-11.4-8.4-19-9.7c-15.7-2.7-10.6,23.3-5.4,24.4 C1735,722.3,1744.9,721.8,1753,720.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1741.2,691.6l-5.7,34c0,0-16.9,2.9-43-1.2c-15.9-2.5-26.5-6.4-32.2-9.1c-3.6-1.7-5.4-2.9-5.4-2.9l6-35.7 c1.5-0.8,3.6-1.3,6.1-1.5c20.8-1.9,71,14.6,71,14.6L1741.2,691.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1667,675.2l-6.7,40.1c-3.6-1.7-5.4-2.9-5.4-2.9l6-35.7C1662.4,675.9,1664.5,675.4,1667,675.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2090.9,709.1c0.7-0.6,60-9.2,97.9,1.7L2151,725l-59.1-10.7C2092,714.3,2087.6,712.1,2090.9,709.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1938.2,639.8c0,0-25,37.5-29.7,43.1s-14.4,8.4-14.4,8.4l-0.1,0l-61.9,12.7c0,0-75.7-13.3-92.1-16.6l0,0 c-1.5-0.3-2.5-0.5-2.9-0.6c-5-1.4-7.2-3.5-6.2-4.9c1-1.3,118.3,0.7,131.3,1c0.1,0,0.3,0,0.4,0c12.6,0.2,14-3,14-3l50.4-38.2 c0.7-0.7,1.7-1.2,2.9-1.6C1933.4,639.3,1938.2,639.8,1938.2,639.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1929.8,640.3c-13.6,11-51.2,41.2-54.7,43.1c-3.8,2.1-109.2,3.6-135.1,4l0,0c-1.5-0.3-2.5-0.5-2.9-0.6 c-5-1.4-7.2-3.5-6.2-4.9c1-1.3,118.3,0.7,131.3,1c13,0.3,14.3-3,14.3-3l50.4-38.2C1927.6,641.1,1928.6,640.6,1929.8,640.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1938.2,639.8c0,0-25,37.5-29.7,43.1s-14.4,8.4-14.4,8.4l-0.1,0c-13.2-1.7-24.2-5.4-31.4-8.3 c12.6,0.2,14-3,14-3l50.4-38.2c0.7-0.7,1.7-1.2,2.9-1.6C1933.4,639.3,1938.2,639.8,1938.2,639.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2140.7,709.9l-177.2-37.1c0,0,83.2-4.3,92.1-11.1c8.4-6.5,98.5-84.2,124.1-90.7 c-23.5,22.9-78,78.2-76.7,96.3C2104.2,684.4,2128.5,702.1,2140.7,709.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3174.2,1631.6c0,1,0,1.9,0,2.9c0,2-0.1,4-0.2,6.1c-0.9,24.8-5.1,49.2-13.6,73.2c-0.4,1-0.7,2.1-1.1,3.2 c-15.8,42.6-45.2,84.3-93.9,125.5c-9.9,8.3-20.5,16.7-32,25c-2.7,1.9-5.4,3.9-8.2,5.8l-2856-0.9c0,0-0.7-1.7-1.9-5 c-7.2-18.7-33.1-89.1-57.8-187.1C52.6,1455,2.2,1083.5,202,857.9c235.6-266,447.5-297.5,644.7-301.6c34.7-0.7,68.9-0.6,102.8-0.7 c34.2-0.1,68-0.6,101.4-2.4c23.6-1.3,46.9-3.3,70.1-6.5c114.8-15.6,225.6-58.7,334.7-178.4c19.3-21.1,39.4-41.1,60.4-59.8l0,0 c207.5-185.4,493.6-254.2,765.1-230.1c34.1,3,67.9,7.5,101.4,13.4c132.2,23.3,257.9,68.8,365.8,133.6c15.9,9.5,31.4,19.5,46.5,29.9 C2890.4,320.9,2969,403,3021.4,499c34.7,63.5,57.9,133.1,67,208.2c1.9,15.2,3.1,30.5,3.8,46.2v0c2.7,61.4-3.9,126.2-21.1,194 c-16.1,63.8-19.9,123.9-15.9,180.9C3069,1326.3,3175.2,1486.6,3174.2,1631.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M3071.2,947.4c-16.1,63.8-19.9,123.9-15.9,180.9l-176.4,269l-65.9,100.5l-29,44.2l-66.5,101.4l-147,224.1 h-272.7l1.7-2.5l44.5-65.3l2.9-4.3l18.9-27.7l16.7-24.6l24.7-36.3l0.3-0.4l2.7-3.9l13.9-20.3l39-57.2l15.1-22.2l206.6-303.2 l40.8-59.9l33.8-49.6l110.9-162.8l13.1-19.2l28-41.1l177-259.8c1.9,15.2,3.1,30.5,3.8,46.2v0 C3094.9,814.8,3088.4,879.6,3071.2,947.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2794.9,255.3L1737.5,1867.5h-63.7l1074.5-1642C2764.3,235,2779.8,245,2794.9,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1516.1,308.5l-1022.5,1559H220.8L1121,546.7c114.8-15.6,225.6-58.7,334.7-178.4 C1475,347.1,1495.1,327.2,1516.1,308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1849.4,374c5.7-2.2,12.6-3.5,19.2-4.2l-29.9-55.2c0,0,0,0,7.8-2c7.8-2,55.1,32,59.3,34.6 c3.4,2.1,28,1.6,37.2,1.3c6.6-1.8,13.6-3.8,21.1-5.9c-3.8-4.7-7.8-9.7-7.8-9.7s2.1-0.4,3.7-0.1c0.5,0.1,1,0.3,1.3,0.6l11.1,6.9 c26.5-7.3,56.4-15.6,83-22.8c40-10.9,72.1-19.6,72.1-19.6c20.2-5.4,32.6-2.7,38.7-0.5c1.7,0.6,2.9,1.2,3.6,1.5c0,0,0.1,0,0.1,0.1 c3.1,1.5,12.6,0.4,16.1,5.2c3.5,4.8-19.5,18.2-30.8,22.9c-3.8,1.6-24.5,7.5-51.2,15c-7.2,2-14.7,4.1-22.5,6.2l1.3,5.1 c0,0-0.7,0.6-2.2,1.5c-2.4,1.4-6.9,3.6-13.7,5.3c-11.2,2.8-18.7,2.2-18.7,2.2l-0.4-1.6c-2,0.2-4.9,0.2-7.5,0 c-0.6-0.1-1.2-0.3-1.7-0.7c-36.8,10-70.3,19-79.4,21.4c-16.2,4.3-54.4,4.2-75.9,3.7c-0.1,0-0.1,0-0.1,0c-6-0.1-10.8-0.3-13.3-0.5 c-0.6,0-1-0.1-1.4-0.1c-1-0.1-1.8-0.3-2.4-0.7c-2.2-1.3-3-4-3.3-6.3L1849.4,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1050.9,553.2v1314.3H949.5V555.6C983.7,555.5,1017.5,555.1,1050.9,553.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2382.6,91.8v1775.6h-101.4V78.4C2315.3,81.4,2349.1,85.9,2382.6,91.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "278.2,1767.6 1476.5,1767.6 1469.2,1398.4 285.6,1398.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M275.4,1870.8h-0.5c-2.7,0-4.9-3.8-4.8-8.3l7.3-535.2l21.6-4.2l-18.4,539.5 C280.4,1867.2,278.1,1870.8,275.4,1870.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234,1337.1h1263.5c7.7,0,14-6.5,14-14.5v-3.2c0-8-6.3-14.5-14-14.5H234c-7.7,0-14,6.5-14,14.5v3.2 C220,1330.6,226.3,1337.1,234,1337.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M454.2,1067l-18.1,224.1c0,0-1.9,13.6,7.8,13.6c16,0,79.5,0,79.5,0s-12-2.8-11.9-9.2 c0.2-7.5,21.2-230.6,21.2-230.6L454.2,1067z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M528.6,1300.7c-3.1,0-63.8,0.2-79.4,0c-6.8-0.1-8-6.3-8-10.3c0-1.9,0.2-3.3,0.2-3.3l0.5-5.8l1.2-14.8 l1.1-13.1l1.4-16.9l1.2-14.2l12.9-159.2l78.5-2.1c0,0-8.9,93.4-15.1,161.4c-0.7,7.6-1.4,14.8-2,21.6c-0.2,2.2-0.4,4.3-0.6,6.3 c-0.6,6.4-1.1,12.3-1.6,17.6c-0.2,2.7-0.5,5.3-0.7,7.6c-0.8,9.2-1.3,15-1.3,16.1c0,0.6,0.1,1.3,0.2,1.8 C518.3,1300.4,527.4,1300.7,528.6,1300.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "263.5,945.1 307.7,1129.5 313.7,1154.8 334.3,1240.6 716.3,1240.6 640.5,945.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "263.5,945.1 257.4,947.2 326.1,1247.1 334.3,1240.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "326.1,1247.1 705.8,1247.1 716.3,1240.6 334.3,1240.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.5,
    y: 1300.8,
    className: "st14",
    width: 82.2,
    height: 4.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "697.8,1186.2 635.8,949 262.9,949 262.9,945.1 640.5,945.1 702.3,1185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "520.8,1247.1 520.4,1250.2 443,1266.4 444.1,1253.3 444.6,1247.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M528.6,1300.7c-3.1,0-63.8,0.2-79.4,0c-6.8-0.1-8-6.3-8-10.3l77-15.1c-0.8,9.2-1.3,15-1.3,16.1 c0,0.6,0.1,1.3,0.2,1.8C518.3,1300.4,527.4,1300.7,528.6,1300.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "502.1,1180.8 334.3,1240.6 313.7,1154.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "263.5,945.1 640.5,945.1 701.7,1182.6 318.4,1182.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "683.9,1172.3 330.9,1172.3 290.9,1006.7 287.9,994 285.3,983.2 279.1,957.8 627,957.8 633.8,983.2  636.6,994 640,1006.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M527.1,1069.7c-4.1,0-8.3-3.2-9.4-7.1l0,0c-0.5-1.9-0.3-3.7,0.7-5.1c1.1-1.5,2.8-2.3,4.9-2.3c0,0,0,0,0,0 c4.1,0,8.3,3.2,9.4,7.1c0.5,1.9,0.3,3.7-0.7,5.1C531,1068.9,529.3,1069.7,527.1,1069.7C527.2,1069.7,527.2,1069.7,527.1,1069.7z  M518.7,1062.4c1,3.5,4.8,6.4,8.5,6.4c0,0,0,0,0,0c1.8,0,3.3-0.7,4.1-1.9c0.8-1.2,1-2.7,0.6-4.3c-1-3.5-4.8-6.4-8.5-6.4 c0,0,0,0,0,0c-1.8,0-3.3,0.7-4.1,1.9C518.4,1059.2,518.2,1060.8,518.7,1062.4L518.7,1062.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M533.4,1092.6c-17.2,0-34.8-13.3-39.4-29.8l0,0c-2.2-7.9-1.2-15.3,2.9-21.1c4.3-6,11.5-9.4,20.1-9.4 c0.1,0,0.1,0,0.2,0c17.2,0,34.8,13.3,39.4,29.8c2.2,7.9,1.2,15.3-2.9,21.1c-4.3,6-11.5,9.4-20.1,9.4 C533.5,1092.6,533.4,1092.6,533.4,1092.6z M495,1062.5c4.5,16,21.6,29,38.3,29c0.1,0,0.1,0,0.2,0c8.3,0,15.1-3.2,19.2-9 c3.9-5.4,4.9-12.5,2.8-20c-4.5-16-21.7-29-38.3-29c-0.1,0-0.1,0-0.2,0c-8.3,0-15.1,3.2-19.2,9C493.9,1047.9,493,1055,495,1062.5 L495,1062.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M540.4,1118.2c-31.8,0-64.5-24.7-73.1-55.2c-4.1-14.5-2.1-28.3,5.4-38.8c8-11.1,21.1-17.3,37.1-17.4 c0.1,0,0.2,0,0.4,0c31.8,0,64.5,24.7,73.1,55.2c4.1,14.5,2.1,28.3-5.4,38.8c-8,11.1-21.1,17.3-37.1,17.4 C540.6,1118.2,540.5,1118.2,540.4,1118.2z M510.2,1007.8c-0.1,0-0.2,0-0.3,0c-15.6,0.1-28.5,6.1-36.3,16.9 c-7.4,10.3-9.2,23.7-5.2,37.9l0,0c8.4,30.1,40.7,54.5,72.1,54.5c0.1,0,0.2,0,0.3,0c15.6-0.1,28.5-6.1,36.3-16.9 c7.4-10.3,9.2-23.7,5.2-37.9C573.8,1032.2,541.5,1007.8,510.2,1007.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M546,1138.6c-44.6,0-90.5-34.7-102.5-77.5c-5.7-20.3-3-39.6,7.6-54.3c11.2-15.6,29.6-24.2,51.9-24.3 c0.2,0,0.3,0,0.5,0c44.6,0,90.5,34.7,102.5,77.5c5.7,20.3,3,39.6-7.6,54.3c-11.2,15.6-29.6,24.2-51.9,24.3 C546.3,1138.6,546.1,1138.6,546,1138.6z M503.5,983.4c-0.2,0-0.3,0-0.5,0c-22,0.1-40.2,8.6-51.2,23.9 c-10.4,14.5-13,33.5-7.4,53.5c11.9,42.4,57.4,76.8,101.6,76.8c0.2,0,0.3,0,0.5,0c22-0.1,40.2-8.6,51.2-23.9 c10.4-14.5,13-33.5,7.4-53.5C593.2,1017.7,547.7,983.4,503.5,983.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M550.6,1155.3c-54.2,0-109.9-42.1-124.5-94.1c-6.9-24.6-3.6-48,9.2-65.9c13.5-18.9,35.9-29.4,63-29.5 c0.2,0,0.4,0,0.6,0c54.2,0,109.9,42.1,124.5,94.1c6.9,24.6,3.6,48-9.2,65.9c-13.5,18.9-35.9,29.4-63,29.5 C551,1155.3,550.8,1155.3,550.6,1155.3z M498.9,966.5c-0.2,0-0.4,0-0.6,0c-26.9,0.1-49,10.5-62.4,29.2 c-12.7,17.7-15.9,40.8-9,65.2c14.5,51.7,69.9,93.5,123.8,93.5c0.2,0,0.4,0,0.6,0c26.9-0.1,49-10.5,62.4-29.2 c12.7-17.7,15.9-40.8,9-65.2C608.2,1008.4,552.7,966.5,498.9,966.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "331.6,979.2 308.1,979.5 307.6,977.4 331.1,977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "326.5,985 309.5,985.3 309,983.1 325.9,982.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "345.9,984.7 329,985 328.4,982.9 345.4,982.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "359.9,984.5 349.5,984.7 348.9,982.6 359.4,982.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "350.5,978.9 336,979.1 335.5,977 350,976.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "370.4,978.6 355.8,978.8 355.3,976.7 369.8,976.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "593.1,969.4 577.2,969.6 576.8,968.2 592.7,968  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "589.6,973.4 578.2,973.5 577.8,972.1 589.2,971.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "602.7,973.2 591.3,973.3 590.9,971.9 602.3,971.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "612.2,973 605.1,973.1 604.7,971.7 611.8,971.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "605.8,969.2 596,969.4 595.7,967.9 605.5,967.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "619.2,969 609.4,969.2 609,967.7 618.8,967.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "635.4,1157.6 619.5,1157.8 619.2,1156.4 635.1,1156.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "631.9,1161.6 620.5,1161.7 620.1,1160.3 631.6,1160.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "645,1161.4 633.6,1161.5 633.3,1160.1 644.7,1159.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "654.5,1161.2 647.4,1161.3 647.1,1159.9 654.2,1159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "648.1,1157.4 638.4,1157.6 638,1156.1 647.8,1156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "661.5,1157.2 651.7,1157.4 651.4,1155.9 661.2,1155.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "332.6,997.9 312.7,998.2 312.2,996.1 332.1,995.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "347.3,997.7 336.2,997.9 335.7,995.8 346.8,995.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "369.4,997.4 352.4,997.6 351.8,995.5 368.9,995.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "337.6,1003.5 314.1,1003.8 313.6,1001.7 337.1,1001.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "332.4,1009.3 315.5,1009.6 315,1007.5 331.9,1007.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "351.9,1009 335,1009.3 334.4,1007.2 351.4,1006.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "365.9,1008.8 355.5,1009 354.9,1006.9 365.4,1006.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "356.5,1003.2 342,1003.4 341.5,1001.3 356,1001.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "376.3,1002.9 361.8,1003.1 361.3,1001 375.8,1000.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "339.2,1024.6 319.3,1024.9 318.8,1022.7 338.6,1022.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "353.9,1024.4 342.8,1024.5 342.3,1022.4 353.4,1022.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "375.9,1024 358.9,1024.3 358.4,1022.1 375.4,1021.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "344.2,1030.1 320.7,1030.4 320.1,1028.3 343.7,1028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "339,1036 322.1,1036.2 321.6,1034.1 338.5,1033.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "358.4,1035.7 341.5,1035.9 341,1033.8 357.9,1033.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "372.5,1035.5 362,1035.6 361.5,1033.5 372,1033.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "363.1,1029.8 348.6,1030 348,1027.9 362.6,1027.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "382.9,1029.5 368.4,1029.8 367.9,1027.6 382.4,1027.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "345.4,1050 325.6,1050.3 325.1,1048.2 344.9,1047.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "360.2,1049.8 349.1,1050 348.5,1047.9 359.6,1047.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "382.2,1049.5 365.2,1049.8 364.7,1047.6 381.7,1047.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "350.5,1055.6 326.9,1055.9 326.4,1053.8 349.9,1053.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "345.3,1061.4 328.4,1061.7 327.8,1059.6 344.8,1059.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "364.7,1061.2 347.8,1061.4 347.3,1059.3 364.2,1059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "378.8,1061 368.3,1061.1 367.8,1059 378.3,1058.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "369.4,1055.3 354.8,1055.5 354.3,1053.4 368.8,1053.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "389.2,1055 374.7,1055.2 374.1,1053.1 388.7,1052.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "351.9,1076.2 332,1076.5 331.5,1074.4 351.4,1074.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "366.6,1076 355.5,1076.1 355,1074 366.1,1073.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "388.7,1075.7 371.6,1075.9 371.1,1073.8 388.1,1073.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "356.9,1081.7 333.4,1082.1 332.9,1079.9 356.4,1079.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "351.7,1087.6 334.8,1087.8 334.3,1085.7 351.2,1085.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "371.2,1087.3 354.2,1087.6 353.7,1085.4 370.6,1085.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "385.2,1087.1 374.7,1087.3 374.2,1085.1 384.7,1085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "375.8,1081.5 361.3,1081.7 360.8,1079.5 375.3,1079.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "395.6,1081.2 381.1,1081.4 380.6,1079.3 395.1,1079  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "359.5,1108.5 339.6,1108.8 339.1,1106.6 359,1106.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "374.2,1108.2 363.1,1108.4 362.6,1106.3 373.7,1106.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "396.3,1107.9 379.2,1108.2 378.7,1106 395.7,1105.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "364.5,1114 341,1114.3 340.5,1112.2 364,1111.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "359.3,1119.9 342.4,1120.1 341.9,1118 358.8,1117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "378.8,1119.6 361.9,1119.8 361.3,1117.7 378.2,1117.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "392.8,1119.4 382.3,1119.5 381.8,1117.4 392.3,1117.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "383.4,1113.7 368.9,1113.9 368.4,1111.8 382.9,1111.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "403.2,1113.4 388.7,1113.6 388.2,1111.5 402.7,1111.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "367.1,1138.6 347.2,1138.9 346.7,1136.8 366.6,1136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "381.8,1138.4 370.7,1138.6 370.2,1136.5 381.3,1136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "403.9,1138.1 386.9,1138.4 386.3,1136.2 403.3,1136  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "372.1,1144.2 348.6,1144.5 348.1,1142.4 371.6,1142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "366.9,1150.1 350,1150.3 349.5,1148.2 366.4,1147.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "386.4,1149.8 369.5,1150 368.9,1147.9 385.9,1147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "400.4,1149.6 390,1149.7 389.4,1147.6 399.9,1147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "391,1143.9 376.5,1144.1 376,1142 390.5,1141.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "410.9,1143.6 396.3,1143.8 395.8,1141.7 410.3,1141.5  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 455.8,
    y: 1024.3,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.4,
    y: 1134,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519,
    y: 1126.1,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.5,
    y: 1079.8,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.2,
    y: 1084.1,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 1004.1,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.6,
    y: 1058.2,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.1,
    y: 1051.4,
    className: "st17",
    width: 11.4,
    height: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M463.8,1032.1c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3 C464.4,1033.4,463.8,1032.8,463.8,1032.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M520.8,1051.4c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C521.4,1052.7,520.8,1052.1,520.8,1051.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M538,1004.1c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C538.6,1005.4,538,1004.8,538,1004.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M568.3,1060c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3 C568.8,1061.3,568.3,1060.7,568.3,1060z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M514.3,1124.8c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C514.9,1126.1,514.3,1125.5,514.3,1124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M457.1,1130.4c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C457.6,1131.7,457.1,1131.1,457.1,1130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M629.8,1080.5c0.1-0.7,0.7-1.2,1.4-1.2c0.7,0.1,1.2,0.7,1.1,1.5c-0.1,0.7-0.7,1.2-1.4,1.2 C630.2,1081.8,629.7,1081.2,629.8,1080.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M460.7,1076.5c0.1-0.7,0.7-1.2,1.4-1.2c0.7,0.1,1.2,0.7,1.1,1.5c-0.1,0.7-0.7,1.2-1.4,1.2 C461.1,1077.8,460.6,1077.2,460.7,1076.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1540.3,1067l-18.1,224.1c0,0-1.9,13.6,7.8,13.6c16,0,79.5,0,79.5,0s-12-2.8-11.9-9.2 c0.2-7.5,21.2-230.6,21.2-230.6L1540.3,1067z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1614.7,1300.7c-3.1,0-63.8,0.2-79.4,0c-6.8-0.1-8-6.3-8-10.3c0-1.9,0.2-3.3,0.2-3.3l0.5-5.8l1.2-14.8 l1.1-13.1l1.4-16.9l1.2-14.2l12.9-159.2l78.5-2.1c0,0-8.9,93.4-15.1,161.4c-0.7,7.6-1.4,14.8-2,21.6c-0.2,2.2-0.4,4.3-0.6,6.3 c-0.6,6.4-1.1,12.3-1.6,17.6c-0.2,2.7-0.5,5.3-0.7,7.6c-0.8,9.2-1.3,15-1.3,16.1c0,0.6,0.1,1.3,0.2,1.8 C1604.4,1300.4,1613.5,1300.7,1614.7,1300.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "1349.6,945.1 1393.7,1129.5 1399.8,1154.8 1420.3,1240.6 1802.4,1240.6 1726.6,945.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "1349.6,945.1 1343.5,947.2 1412.2,1247.1 1420.3,1240.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1412.2,1247.1 1791.9,1247.1 1802.4,1240.6 1420.3,1240.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1545.5,
    y: 1300.8,
    className: "st14",
    width: 82.2,
    height: 4.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "1783.9,1186.2 1721.9,949 1349,949 1349,945.1 1726.6,945.1 1788.4,1185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1606.9,1247.1 1606.4,1250.2 1529.1,1266.4 1530.2,1253.3 1530.7,1247.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1614.7,1300.7c-3.1,0-63.8,0.2-79.4,0c-6.8-0.1-8-6.3-8-10.3l77-15.1c-0.8,9.2-1.3,15-1.3,16.1 c0,0.6,0.1,1.3,0.2,1.8C1604.4,1300.4,1613.5,1300.7,1614.7,1300.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1588.2,1180.8 1420.3,1240.6 1399.8,1154.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "1349.6,945.1 1726.6,945.1 1787.8,1182.6 1404.5,1182.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "1770,1172.3 1417,1172.3 1377,1006.7 1373.9,994 1371.3,983.2 1365.2,957.8 1713.1,957.8  1719.8,983.2 1722.7,994 1726.1,1006.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1417.7,979.2 1394.2,979.5 1393.7,977.4 1417.2,977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1412.5,985 1395.6,985.3 1395.1,983.1 1412,982.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1432,984.7 1415,985 1414.5,982.9 1431.4,982.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1446,984.5 1435.5,984.7 1435,982.6 1445.5,982.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1436.6,978.9 1422.1,979.1 1421.6,977 1436.1,976.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1456.4,978.6 1441.9,978.8 1441.4,976.7 1455.9,976.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1679.2,969.4 1663.3,969.6 1662.9,968.2 1678.8,968  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1675.6,973.4 1664.2,973.5 1663.9,972.1 1675.3,971.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1688.8,973.2 1677.3,973.3 1677,971.9 1688.4,971.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1698.2,973 1691.2,973.1 1690.8,971.7 1697.9,971.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1691.9,969.2 1682.1,969.4 1681.7,967.9 1691.5,967.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1705.3,969 1695.5,969.2 1695.1,967.7 1704.9,967.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1721.5,1157.6 1705.6,1157.8 1705.3,1156.4 1721.1,1156.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1718,1161.6 1706.6,1161.7 1706.2,1160.3 1717.6,1160.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1731.1,1161.4 1719.7,1161.5 1719.3,1160.1 1730.7,1159.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1740.6,1161.2 1733.5,1161.3 1733.2,1159.9 1740.2,1159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1734.2,1157.4 1724.4,1157.6 1724.1,1156.1 1733.9,1156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1747.6,1157.2 1737.8,1157.4 1737.5,1155.9 1747.2,1155.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1418.7,997.9 1398.8,998.2 1398.3,996.1 1418.2,995.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1433.4,997.7 1422.3,997.9 1421.8,995.8 1432.9,995.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1455.4,997.4 1438.4,997.6 1437.9,995.5 1454.9,995.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1423.7,1003.5 1400.2,1003.8 1399.7,1001.7 1423.2,1001.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1418.5,1009.3 1401.6,1009.6 1401.1,1007.5 1418,1007.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1438,1009 1421,1009.3 1420.5,1007.2 1437.4,1006.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1452,1008.8 1441.5,1009 1441,1006.9 1451.5,1006.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1442.6,1003.2 1428.1,1003.4 1427.6,1001.3 1442.1,1001.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1462.4,1002.9 1447.9,1003.1 1447.4,1001 1461.9,1000.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1425.2,1024.6 1405.4,1024.9 1404.8,1022.7 1424.7,1022.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1440,1024.4 1428.8,1024.5 1428.3,1022.4 1439.4,1022.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1462,1024 1445,1024.3 1444.5,1022.1 1461.5,1021.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1430.3,1030.1 1406.7,1030.4 1406.2,1028.3 1429.7,1028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1425.1,1036 1408.2,1036.2 1407.6,1034.1 1424.6,1033.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1444.5,1035.7 1427.6,1035.9 1427.1,1033.8 1444,1033.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1458.6,1035.5 1448.1,1035.6 1447.6,1033.5 1458,1033.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1449.2,1029.8 1434.6,1030 1434.1,1027.9 1448.6,1027.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1469,1029.5 1454.5,1029.8 1453.9,1027.6 1468.5,1027.4  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1501,1020.8 1555.9,1025.3 1576,1046.5 1570.4,1088 1592.2,1125.3 1564.8,1136.5 1509.7,1125.3  1486.5,1057.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1576,1007.3 1635,975.3 1668.6,983.6 1688.5,1029.9 1733.8,1053.6 1712.6,1083.4 1649.3,1108.6  1583.6,1054.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1431.5,1050 1411.6,1050.3 1411.1,1048.2 1431,1047.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1446.2,1049.8 1435.1,1050 1434.6,1047.9 1445.7,1047.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1468.3,1049.5 1451.3,1049.8 1450.7,1047.6 1467.8,1047.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1436.5,1055.6 1413,1055.9 1412.5,1053.8 1436,1053.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1431.4,1061.4 1414.4,1061.7 1413.9,1059.6 1430.8,1059.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1450.8,1061.2 1433.9,1061.4 1433.3,1059.3 1450.3,1059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1464.9,1061 1454.4,1061.1 1453.8,1059 1464.3,1058.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1455.4,1055.3 1440.9,1055.5 1440.4,1053.4 1454.9,1053.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1475.3,1055 1460.7,1055.2 1460.2,1053.1 1474.7,1052.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1438,1076.2 1418.1,1076.5 1417.6,1074.4 1437.4,1074.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1452.7,1076 1441.6,1076.1 1441,1074 1452.1,1073.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1474.7,1075.7 1457.7,1075.9 1457.2,1073.8 1474.2,1073.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1443,1081.7 1419.5,1082.1 1418.9,1079.9 1442.5,1079.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1437.8,1087.6 1420.9,1087.8 1420.4,1085.7 1437.3,1085.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1457.2,1087.3 1440.3,1087.6 1439.8,1085.4 1456.7,1085.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1471.3,1087.1 1460.8,1087.3 1460.3,1085.1 1470.8,1085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1461.9,1081.5 1447.4,1081.7 1446.8,1079.5 1461.3,1079.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1481.7,1081.2 1467.2,1081.4 1466.7,1079.3 1481.2,1079  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1445.6,1108.5 1425.7,1108.8 1425.2,1106.6 1445,1106.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1460.3,1108.2 1449.2,1108.4 1448.6,1106.3 1459.7,1106.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1482.3,1107.9 1465.3,1108.2 1464.8,1106 1481.8,1105.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1450.6,1114 1427.1,1114.3 1426.5,1112.2 1450.1,1111.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1445.4,1119.9 1428.5,1120.1 1428,1118 1444.9,1117.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1464.8,1119.6 1447.9,1119.8 1447.4,1117.7 1464.3,1117.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1478.9,1119.4 1468.4,1119.5 1467.9,1117.4 1478.4,1117.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1469.5,1113.7 1455,1113.9 1454.4,1111.8 1468.9,1111.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1489.3,1113.4 1474.8,1113.6 1474.3,1111.5 1488.8,1111.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1453.2,1138.6 1433.3,1138.9 1432.8,1136.8 1452.7,1136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1467.9,1138.4 1456.8,1138.6 1456.3,1136.5 1467.4,1136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1489.9,1138.1 1472.9,1138.4 1472.4,1136.2 1489.4,1136  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1458.2,1144.2 1434.7,1144.5 1434.2,1142.4 1457.7,1142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1453,1150.1 1436.1,1150.3 1435.6,1148.2 1452.5,1147.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1472.5,1149.8 1455.5,1150 1455,1147.9 1471.9,1147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1486.5,1149.6 1476,1149.7 1475.5,1147.6 1486,1147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1477.1,1143.9 1462.6,1144.1 1462.1,1142 1476.6,1141.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1496.9,1143.6 1482.4,1143.8 1481.9,1141.7 1496.4,1141.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1643.6,1053.4 1604.1,1050.2 1589.7,1015.4 1496.9,1007.2 1497,1006.2 1590.4,1014.5  1604.7,1049.3 1643.7,1052.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1522,1114.4 1522,1113.4 1595,1112 1663.8,1085.9 1725.3,1092.4 1725.2,1093.4 1663.9,1086.9  1595.2,1113 1595.1,1113  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1717.7,1070.1 1675.4,1042.4 1632.1,1022.3 1614.2,985.2 1615.1,984.8 1632.8,1021.5  1675.8,1041.5 1718.2,1069.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1681.3,1147.5 1675.2,1117.6 1603.7,1085.9 1603.7,1085.8 1568.5,1050.5 1509.7,1053.4  1509.7,1052.4 1568.9,1049.5 1604.3,1085.1 1676.1,1116.9 1682.2,1147.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1686.7,1010.1 1643.6,995.8 1586.6,998.7 1586.5,998.7 1537,984.5 1537.2,983.6 1586.7,997.7  1643.7,994.8 1643.8,994.8 1687,1009.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1527.3,1085.5 1527.1,1084.5 1562.7,1076 1638.5,1041.7 1713.3,1029.3 1713.5,1030.2  1638.7,1042.7 1563,1076.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1657.6,1131.1 1656.7,1130.9 1663.3,1099 1622.1,1079.4 1580.8,1039.2 1580.8,1039 1564.3,983  1565.2,982.8 1581.6,1038.6 1622.6,1078.6 1664.4,1098.4 1664.3,1098.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1711.8,1131.4 1688.3,1105.1 1670.6,1061.9 1662.4,1011.7 1691.6,991.1 1692.2,991.9  1663.4,1012.1 1671.5,1061.6 1689.2,1104.7 1712.5,1130.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1512.3,1044.5c0-1.2,1-2.3,2.2-2.3c1.2,0,2.2,1,2.2,2.3s-1,2.3-2.2,2.3 C1513.2,1046.7,1512.3,1045.7,1512.3,1044.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1597.8,1014c0-1.2,1-2.3,2.2-2.3c1.2,0,2.2,1,2.2,2.3c0,1.2-1,2.3-2.2,2.3 C1598.8,1016.2,1597.8,1015.2,1597.8,1014z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1686.6,1023.1c0-1.2,1-2.3,2.2-2.3s2.2,1,2.2,2.3c0,1.2-1,2.3-2.2,2.3S1686.6,1024.3,1686.6,1023.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1612.1,1131c0-1.2,1-2.3,2.2-2.3s2.2,1,2.2,2.3c0,1.2-1,2.3-2.2,2.3 C1613.1,1133.3,1612.1,1132.3,1612.1,1131z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1516.6,
    y: 1032.1,
    className: "st14",
    width: 23.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1583.2,
    y: 986,
    className: "st14",
    width: 23.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1597.8,
    y: 1018,
    className: "st17",
    width: 23.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1604.8,
    y: 1122.5,
    className: "st17",
    width: 23.5,
    height: 2.8
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1403.7,1767.6 2408.6,1767.6 2402.5,1398.4 1410,1398.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2476.4,1870.8h0.5c2.7,0,4.9-3.8,4.8-8.3l-7.3-535.2l-21.6-4.2l18.4,539.5 C2471.4,1867.2,2473.6,1870.8,2476.4,1870.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1399.3,1337.1h1089.9c7.2,0,13-6,13-13.5v-5.3c0-7.4-5.8-13.5-13-13.5H1399.3c-7.2,0-13,6-13,13.5v5.3 C1386.3,1331.1,1392.1,1337.1,1399.3,1337.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "985.6,1074 1019.5,1215.5 1024.1,1234.9 1039.9,1300.8 1333.1,1300.8 1274.9,1074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "985.6,1074 980.9,1075.7 1033.7,1305.7 1039.9,1300.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1033.7,1305.7 1325,1305.7 1333.1,1300.8 1039.9,1300.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "1168.7,1254.9 1039.9,1300.8 1024.1,1234.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "985.6,1074 1274.9,1074 1321.9,1256.3 1027.8,1256.3  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "1308.2,1248.4 1037.4,1248.4 1006.7,1121.3 1004.3,1111.6 1002.3,1103.3 997.6,1083.8  1264.6,1083.8 1269.7,1103.3 1271.9,1111.6 1274.5,1121.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1008.7,1092.6c-0.3-1.3,0.5-2.4,1.8-2.4c1.3,0,2.6,1.1,2.9,2.4s-0.5,2.4-1.8,2.4 C1010.3,1095,1009,1093.9,1008.7,1092.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1016.4,1092.6c-0.3-1.3,0.5-2.4,1.8-2.4c1.3,0,2.6,1.1,2.9,2.4c0.3,1.3-0.5,2.4-1.8,2.4 C1018.1,1095,1016.8,1093.9,1016.4,1092.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1024.8,1092.6c-0.3-1.3,0.5-2.4,1.8-2.4c1.3,0,2.6,1.1,2.9,2.4c0.3,1.3-0.5,2.4-1.8,2.4 C1026.5,1095,1025.1,1093.9,1024.8,1092.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "996.3,1083.8 1264.7,1083.8 1308.2,1249.1 1035.4,1249.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1295.6,1241.9 1044.3,1241.9 1015.8,1126.7 1013.7,1117.9 1011.8,1110.3 1007.4,1092.6  1255.1,1092.6 1259.9,1110.3 1261.9,1117.9 1264.3,1126.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1044.8,1107.5 1028.1,1107.7 1027.7,1106.2 1044.4,1106  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1041.1,1111.6 1029.1,1111.7 1028.7,1110.3 1040.7,1110.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1055,1111.4 1042.9,1111.5 1042.5,1110.1 1054.6,1109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1065,1111.2 1057.5,1111.3 1057.1,1109.8 1064.6,1109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1058.3,1107.3 1047.9,1107.4 1047.5,1106 1057.9,1105.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1072.4,1107.1 1062,1107.2 1061.7,1105.8 1072,1105.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1230.9,1100.7 1219.6,1100.9 1219.4,1099.9 1230.7,1099.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1228.4,1103.4 1220.3,1103.6 1220,1102.6 1228.2,1102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1237.7,1103.3 1229.6,1103.4 1229.4,1102.4 1237.5,1102.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1244.5,1103.2 1239.5,1103.3 1239.2,1102.3 1244.2,1102.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1240,1100.6 1233,1100.7 1232.7,1099.7 1239.7,1099.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1249.5,1100.4 1242.5,1100.5 1242.3,1099.5 1249.2,1099.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1261,1231.7 1249.7,1231.8 1249.5,1230.8 1260.8,1230.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1258.5,1234.4 1250.4,1234.5 1250.2,1233.5 1258.3,1233.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1267.9,1234.3 1259.8,1234.4 1259.5,1233.4 1267.6,1233.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1274.6,1234.2 1269.6,1234.2 1269.3,1233.2 1274.4,1233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1270.1,1231.5 1263.1,1231.6 1262.9,1230.6 1269.9,1230.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1279.6,1231.4 1272.7,1231.5 1272.4,1230.5 1279.4,1230.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1045.5,1120.6 1031.4,1120.8 1031,1119.3 1045.1,1119.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1056,1120.4 1048.1,1120.5 1047.7,1119 1055.6,1118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1071.7,1120.2 1059.6,1120.4 1059.2,1118.9 1071.3,1118.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1049.1,1124.4 1032.3,1124.7 1032,1123.2 1048.7,1122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1045.4,1128.5 1033.3,1128.7 1033,1127.2 1045,1127  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1059.2,1128.3 1047.2,1128.5 1046.8,1127 1058.8,1126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1069.2,1128.1 1061.8,1128.3 1061.4,1126.8 1068.9,1126.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1062.5,1124.2 1052.2,1124.4 1051.8,1122.9 1062.2,1122.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1076.6,1124 1066.3,1124.2 1065.9,1122.7 1076.3,1122.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1050.2,1139.1 1036,1139.3 1035.7,1137.8 1049.8,1137.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1060.6,1138.9 1052.7,1139 1052.4,1137.6 1060.3,1137.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1076.3,1138.7 1064.2,1138.9 1063.8,1137.4 1076,1137.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1053.7,1142.9 1037,1143.2 1036.6,1141.7 1053.4,1141.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1050.1,1147 1038,1147.2 1037.6,1145.7 1049.7,1145.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1063.9,1146.8 1051.9,1147 1051.5,1145.5 1063.5,1145.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1073.9,1146.7 1066.4,1146.8 1066.1,1145.3 1073.5,1145.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1067.2,1142.7 1056.9,1142.9 1056.5,1141.4 1066.8,1141.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1081.3,1142.5 1071,1142.7 1070.6,1141.2 1080.9,1141.1  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1104.1,1136.5 1143.2,1139.6 1157.5,1154.3 1153.5,1183.2 1169,1209.2 1149.5,1217 1110.3,1209.2  1093.8,1161.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "1157.5,1127.1 1199.5,1104.8 1223.4,1110.6 1237.6,1142.8 1269.8,1159.3 1254.7,1180  1209.6,1197.6 1162.9,1159.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1054.6,1156.8 1040.5,1157 1040.1,1155.5 1054.3,1155.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1065.1,1156.7 1057.2,1156.8 1056.8,1155.3 1064.7,1155.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1080.8,1156.4 1068.7,1156.6 1068.3,1155.1 1080.4,1155  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1058.2,1160.7 1041.5,1160.9 1041.1,1159.4 1057.8,1159.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1054.5,1164.7 1042.5,1164.9 1042.1,1163.4 1054.2,1163.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1068.4,1164.5 1056.3,1164.7 1055.9,1163.2 1068,1163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1078.4,1164.4 1070.9,1164.5 1070.5,1163 1078,1162.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1071.7,1160.5 1061.3,1160.6 1061,1159.1 1071.3,1159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1085.8,1160.3 1075.4,1160.4 1075.1,1158.9 1085.4,1158.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1059.2,1175 1045.1,1175.2 1044.7,1173.7 1058.9,1173.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1069.7,1174.9 1061.8,1175 1061.4,1173.5 1069.3,1173.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1085.4,1174.6 1073.3,1174.8 1072.9,1173.3 1085,1173.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1062.8,1178.9 1046.1,1179.1 1045.7,1177.6 1062.4,1177.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1059.1,1182.9 1047.1,1183.1 1046.7,1181.6 1058.7,1181.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1072.9,1182.7 1060.9,1182.9 1060.5,1181.4 1072.6,1181.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1083,1182.6 1075.5,1182.7 1075.1,1181.2 1082.6,1181.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1076.2,1178.7 1065.9,1178.8 1065.5,1177.3 1075.9,1177.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1090.4,1178.5 1080,1178.6 1079.7,1177.1 1090,1177  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1064.6,1197.5 1050.5,1197.7 1050.1,1196.2 1064.3,1196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1075.1,1197.3 1067.2,1197.4 1066.8,1195.9 1074.7,1195.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1090.8,1197.1 1078.7,1197.3 1078.3,1195.8 1090.4,1195.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1068.2,1201.3 1051.5,1201.6 1051.1,1200.1 1067.8,1199.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1064.5,1205.4 1052.5,1205.6 1052.1,1204.1 1064.2,1203.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1078.4,1205.2 1066.3,1205.4 1065.9,1203.9 1078,1203.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1088.4,1205 1080.9,1205.2 1080.5,1203.7 1088,1203.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1081.7,1201.1 1071.3,1201.3 1071,1199.8 1081.3,1199.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1095.8,1200.9 1085.4,1201.1 1085.1,1199.6 1095.4,1199.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1070.1,1218.5 1055.9,1218.7 1055.5,1217.2 1069.7,1217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1080.5,1218.3 1072.6,1218.4 1072.3,1217 1080.2,1216.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1096.2,1218.1 1084.1,1218.3 1083.7,1216.8 1095.9,1216.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1073.6,1222.3 1056.9,1222.6 1056.5,1221.1 1073.3,1220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1070,1226.4 1057.9,1226.6 1057.5,1225.1 1069.6,1224.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1083.8,1226.2 1071.7,1226.4 1071.4,1224.9 1083.4,1224.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1093.8,1226.1 1086.3,1226.2 1086,1224.7 1093.4,1224.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1087.1,1222.1 1076.8,1222.3 1076.4,1220.8 1086.7,1220.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1101.2,1221.9 1090.9,1222.1 1090.5,1220.6 1100.8,1220.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1205.6,1159.1 1177.5,1156.9 1167.3,1132.7 1101.2,1127 1101.2,1126.3 1167.7,1132.1  1177.9,1156.3 1205.7,1158.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1119.1,1201.6 1119,1200.9 1171,1199.9 1220,1181.7 1263.7,1186.3 1263.7,1187 1220.1,1182.4  1171.2,1200.6 1171.1,1200.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1258.4,1170.8 1228.2,1151.5 1197.4,1137.5 1184.7,1111.7 1185.3,1111.4 1197.9,1137  1228.6,1150.9 1258.7,1170.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1232.4,1224.7 1228.1,1203.8 1177.2,1181.8 1177.2,1181.7 1152.1,1157.1 1110.3,1159.1  1110.3,1158.4 1152.4,1156.4 1177.6,1181.2 1228.7,1203.3 1233.1,1224.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1236.3,1129 1205.6,1119 1165,1121.1 1165,1121.1 1129.7,1111.2 1129.9,1110.6 1165.1,1120.4  1205.7,1118.4 1205.7,1118.4 1236.5,1128.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1122.8,1181.5 1122.7,1180.8 1148,1174.9 1202,1151 1255.2,1142.4 1255.3,1143 1202.1,1151.7  1148.3,1175.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1215.6,1213.2 1214.9,1213.1 1219.6,1190.9 1190.3,1177.2 1160.9,1149.2 1160.9,1149.2  1149.1,1110.2 1149.8,1110 1161.5,1148.9 1190.7,1176.7 1220.4,1190.5 1220.4,1190.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "1254.1,1213.4 1237.4,1195.1 1224.8,1165.1 1219,1130.1 1239.8,1115.8 1240.2,1116.4  1219.7,1130.4 1225.5,1164.9 1238,1194.8 1254.6,1212.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1112.1,1152.9c0-0.9,0.7-1.6,1.5-1.6c0.9,0,1.5,0.7,1.5,1.6s-0.7,1.6-1.5,1.6 C1112.8,1154.5,1112.1,1153.8,1112.1,1152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1173,1131.7c0-0.9,0.7-1.6,1.5-1.6c0.9,0,1.5,0.7,1.5,1.6s-0.7,1.6-1.5,1.6 C1173.7,1133.3,1173,1132.6,1173,1131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1236.2,1138.1c0-0.9,0.7-1.6,1.5-1.6c0.9,0,1.5,0.7,1.5,1.6s-0.7,1.6-1.5,1.6 C1236.9,1139.6,1236.2,1138.9,1236.2,1138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1183.2,1213.2c0-0.9,0.7-1.6,1.5-1.6c0.9,0,1.5,0.7,1.5,1.6s-0.7,1.6-1.5,1.6 C1183.9,1214.7,1183.2,1214,1183.2,1213.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1115.2,
    y: 1144.3,
    className: "st14",
    width: 16.7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.6,
    y: 1112.3,
    className: "st14",
    width: 16.7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1173,
    y: 1134.5,
    className: "st17",
    width: 16.7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1178,
    y: 1207.2,
    className: "st17",
    width: 16.7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2021.7,1079.8 2054.8,1217.8 2059.3,1236.7 2074.7,1300.9 2360.5,1300.9 2303.8,1079.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2021.7,1079.8 2017.2,1081.4 2068.6,1305.7 2074.7,1300.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2068.6,1305.7 2352.6,1305.7 2360.5,1300.9 2074.7,1300.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2200.2,1256.2 2074.7,1300.9 2059.3,1236.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2021.7,1079.8 2303.8,1079.8 2349.5,1257.5 2062.8,1257.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "2336.2,1249.8 2072.2,1249.8 2042.3,1126 2040,1116.5 2038,1108.4 2033.4,1089.4 2293.7,1089.4  2298.7,1108.4 2300.9,1116.5 2303.4,1126  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2331.7,1246.3 2076.4,1246.3 2047.4,1128.3 2045.2,1119.2 2043.3,1111.5 2038.9,1093.4  2290.6,1093.4 2295.4,1111.5 2297.5,1119.2 2299.9,1128.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2076.9,1108.6 2059.9,1108.8 2059.5,1107.3 2076.5,1107.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2073.1,1112.8 2060.9,1112.9 2060.5,1111.4 2072.8,1111.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2087.2,1112.6 2075,1112.7 2074.6,1111.2 2086.8,1111.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2097.4,1112.4 2089.8,1112.5 2089.4,1111 2097,1110.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2090.6,1108.4 2080,1108.5 2079.7,1107 2090.2,1106.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2104.9,1108.2 2094.4,1108.3 2094,1106.8 2104.5,1106.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2132.9,1105.9 2121.4,1106 2121.1,1105 2132.6,1104.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2130.4,1108.7 2122.1,1108.8 2121.8,1107.8 2130.1,1107.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2139.8,1108.5 2131.6,1108.6 2131.3,1107.6 2139.6,1107.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2146.7,1108.4 2141.6,1108.5 2141.3,1107.5 2146.4,1107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2142.1,1105.7 2135,1105.8 2134.8,1104.8 2141.8,1104.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2151.8,1105.6 2144.7,1105.7 2144.4,1104.7 2151.5,1104.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2296.6,1235.8 2285.1,1235.9 2284.9,1234.9 2296.4,1234.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2294.1,1238.6 2285.8,1238.7 2285.6,1237.7 2293.8,1237.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2303.6,1238.5 2295.3,1238.6 2295.1,1237.6 2303.3,1237.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2310.4,1238.4 2305.3,1238.4 2305.1,1237.4 2310.2,1237.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2305.8,1235.6 2298.8,1235.7 2298.5,1234.7 2305.6,1234.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2315.5,1235.5 2308.4,1235.6 2308.2,1234.6 2315.3,1234.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2077.6,1122 2063.2,1122.2 2062.8,1120.7 2077.2,1120.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2088.2,1121.8 2080.2,1121.9 2079.8,1120.4 2087.8,1120.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2104.2,1121.6 2091.9,1121.8 2091.5,1120.3 2103.8,1120.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2081.2,1125.9 2064.2,1126.2 2063.8,1124.7 2080.8,1124.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2077.5,1130.1 2065.2,1130.3 2064.9,1128.8 2077.1,1128.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2091.5,1129.9 2079.3,1130.1 2078.9,1128.6 2091.2,1128.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2101.7,1129.8 2094.1,1129.9 2093.7,1128.4 2101.3,1128.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2094.9,1125.7 2084.4,1125.9 2084,1124.4 2094.5,1124.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2109.2,1125.5 2098.7,1125.7 2098.3,1124.2 2108.8,1124  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2082.3,1141 2068,1141.2 2067.6,1139.7 2082,1139.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2093,1140.8 2084.9,1140.9 2084.6,1139.4 2092.6,1139.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2108.9,1140.6 2096.6,1140.8 2096.2,1139.2 2108.5,1139.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2086,1144.9 2068.9,1145.2 2068.6,1143.6 2085.6,1143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2082.2,1149.1 2070,1149.3 2069.6,1147.7 2081.8,1147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2096.3,1148.9 2084,1149.1 2083.7,1147.5 2095.9,1147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2106.4,1148.7 2098.9,1148.8 2098.5,1147.3 2106.1,1147.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2099.6,1144.7 2089.1,1144.9 2088.8,1143.3 2099.2,1143.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2114,1144.5 2103.5,1144.7 2103.1,1143.1 2113.6,1143  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2181.1,1154 2166.7,1154.2 2166.4,1152.7 2180.7,1152.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2191.7,1153.9 2183.7,1154 2183.3,1152.5 2191.4,1152.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2207.7,1153.6 2195.4,1153.8 2195,1152.3 2207.3,1152.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2184.7,1158 2167.7,1158.2 2167.3,1156.7 2184.4,1156.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2181,1162.1 2168.8,1162.3 2168.4,1160.8 2180.6,1160.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2195,1161.9 2182.8,1162.1 2182.4,1160.6 2194.7,1160.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2205.2,1161.8 2197.6,1161.9 2197.3,1160.4 2204.8,1160.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2198.4,1157.8 2187.9,1157.9 2187.5,1156.4 2198,1156.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2212.7,1157.6 2202.2,1157.7 2201.9,1156.2 2212.4,1156  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2245.8,1154 2231.4,1154.2 2231,1152.7 2245.4,1152.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2256.4,1153.9 2248.4,1154 2248,1152.5 2256,1152.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2272.4,1153.6 2260,1153.8 2259.7,1152.3 2272,1152.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2249.4,1158 2232.4,1158.2 2232,1156.7 2249,1156.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2245.6,1162.1 2233.4,1162.3 2233,1160.8 2245.3,1160.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2259.7,1161.9 2247.5,1162.1 2247.1,1160.6 2259.3,1160.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2269.9,1161.8 2262.3,1161.9 2261.9,1160.4 2269.5,1160.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2263.1,1157.8 2252.6,1157.9 2252.2,1156.4 2262.7,1156.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2277.4,1157.6 2266.9,1157.7 2266.5,1156.2 2277,1156  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2086.9,1159.1 2072.5,1159.3 2072.1,1157.8 2086.5,1157.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2097.5,1159 2089.5,1159.1 2089.1,1157.6 2097.1,1157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2113.5,1158.7 2101.2,1158.9 2100.8,1157.4 2113.1,1157.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2090.5,1163.1 2073.5,1163.3 2073.1,1161.8 2090.1,1161.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2086.8,1167.2 2074.5,1167.4 2074.1,1165.9 2086.4,1165.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2100.8,1167 2088.6,1167.2 2088.2,1165.7 2100.4,1165.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2111,1166.9 2103.4,1167 2103,1165.5 2110.6,1165.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2104.2,1162.9 2093.7,1163 2093.3,1161.5 2103.8,1161.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2118.5,1162.7 2108,1162.8 2107.6,1161.3 2118.1,1161.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2091.5,1177.8 2077.2,1178 2076.8,1176.5 2091.2,1176.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2102.2,1177.6 2094.1,1177.7 2093.8,1176.2 2101.8,1176.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2118.1,1177.4 2105.8,1177.6 2105.4,1176 2117.7,1175.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2095.2,1181.7 2078.2,1182 2077.8,1180.4 2094.8,1180.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2091.4,1185.9 2079.2,1186.1 2078.8,1184.5 2091,1184.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2105.5,1185.7 2093.2,1185.9 2092.9,1184.3 2105.1,1184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2115.6,1185.5 2108.1,1185.6 2107.7,1184.1 2115.3,1184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2108.8,1181.5 2098.3,1181.7 2098,1180.1 2108.4,1180  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2123.2,1181.3 2112.7,1181.5 2112.3,1179.9 2122.8,1179.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2097,1200.7 2082.7,1200.9 2082.3,1199.4 2096.7,1199.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2107.7,1200.6 2099.6,1200.7 2099.3,1199.2 2107.3,1199.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2123.6,1200.4 2111.3,1200.5 2110.9,1199 2123.2,1198.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2100.7,1204.7 2083.7,1204.9 2083.3,1203.4 2100.3,1203.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2096.9,1208.9 2084.7,1209 2084.3,1207.5 2096.5,1207.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2111,1208.7 2098.7,1208.8 2098.4,1207.3 2110.6,1207.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2121.1,1208.5 2113.6,1208.6 2113.2,1207.1 2120.8,1207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2114.3,1204.5 2103.8,1204.7 2103.5,1203.1 2113.9,1203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2128.7,1204.3 2118.2,1204.4 2117.8,1202.9 2128.3,1202.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2102.5,1222.3 2088.2,1222.5 2087.8,1221 2102.2,1220.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2113.2,1222.1 2105.2,1222.2 2104.8,1220.7 2112.8,1220.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2129.1,1221.9 2116.8,1222.1 2116.4,1220.6 2128.8,1220.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2106.2,1226.2 2089.2,1226.5 2088.8,1224.9 2105.8,1224.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2102.4,1230.4 2090.2,1230.6 2089.8,1229 2102.1,1228.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2116.5,1230.2 2104.3,1230.4 2103.9,1228.9 2116.1,1228.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2126.7,1230 2119.1,1230.2 2118.7,1228.6 2126.3,1228.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2119.8,1226 2109.3,1226.2 2109,1224.7 2119.5,1224.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2134.2,1225.8 2123.7,1226 2123.3,1224.4 2133.8,1224.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2176.1,1209.5c-1.2,0-2.4-0.9-2.7-2c-0.2-0.5-0.1-1.1,0.2-1.5c0.3-0.4,0.8-0.7,1.4-0.7h0 c1.2,0,2.4,0.9,2.7,2c0.2,0.5,0.1,1.1-0.2,1.5C2177.2,1209.2,2176.7,1209.5,2176.1,1209.5L2176.1,1209.5z M2175,1205.6 L2175,1205.6c-0.5,0-1,0.2-1.2,0.6c-0.2,0.3-0.3,0.8-0.2,1.2c0.3,1,1.4,1.8,2.5,1.8h0c0.5,0,1-0.2,1.2-0.6 c0.2-0.3,0.3-0.8,0.2-1.2C2177.2,1206.4,2176.1,1205.6,2175,1205.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2177.9,1216c-5,0-10.1-3.8-11.4-8.5c-0.6-2.2-0.3-4.4,0.8-6c1.2-1.8,3.3-2.7,5.9-2.7c0,0,0,0,0.1,0 c5,0,10.1,3.8,11.4,8.5c0.6,2.2,0.3,4.4-0.8,6C2182.6,1215,2180.5,1216,2177.9,1216C2177.9,1216,2177.9,1216,2177.9,1216z  M2173.2,1199.1C2173.2,1199.1,2173.1,1199.1,2173.2,1199.1c-2.5,0-4.5,0.9-5.7,2.6c-1.1,1.5-1.4,3.6-0.8,5.7l0,0 c1.3,4.6,6.3,8.3,11.1,8.3c0,0,0,0,0.1,0c2.4,0,4.4-0.9,5.6-2.6c1.1-1.5,1.4-3.6,0.8-5.7 C2183,1202.8,2178,1199.1,2173.2,1199.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2179.9,1223.3c-9.2,0-18.7-7.1-21.2-15.8c-1.2-4.1-0.6-8,1.5-11c2.3-3.2,6.2-5,10.8-5.1 c0,0,0.1,0,0.1,0c9.2,0,18.7,7.1,21.2,15.8c1.2,4.1,0.6,8-1.5,11C2188.5,1221.5,2184.7,1223.3,2179.9,1223.3 C2180,1223.3,2180,1223.3,2179.9,1223.3z M2171.1,1191.8C2171.1,1191.8,2171.1,1191.8,2171.1,1191.8c-4.7,0-8.4,1.8-10.7,4.9 c-2.1,2.9-2.6,6.7-1.5,10.8l0,0c2.5,8.6,11.8,15.6,20.9,15.6c0,0,0.1,0,0.1,0c4.6,0,8.3-1.8,10.6-4.9 c2.1-2.9,2.6-6.7,1.5-10.8C2189.6,1198.7,2180.2,1191.8,2171.1,1191.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2181.5,1229.2c-12.9,0-26.3-9.9-29.8-22.2l0,0c-1.6-5.8-0.9-11.2,2.1-15.4c3.2-4.5,8.6-7,15.2-7.1 c0,0,0.1,0,0.1,0c12.9,0,26.3,9.9,29.8,22.2c1.6,5.8,0.9,11.2-2.1,15.4c-3.2,4.5-8.6,7-15.2,7.1 C2181.6,1229.2,2181.6,1229.2,2181.5,1229.2z M2169.2,1184.8c0,0-0.1,0-0.1,0c-6.5,0-11.8,2.5-15,7c-2.9,4.1-3.7,9.5-2.1,15.2 l0,0c3.5,12.1,16.7,22,29.5,22c0,0,0.1,0,0.1,0c6.5,0,11.8-2.5,15-7c2.9-4.1,3.7-9.5,2.1-15.2 C2195.2,1194.6,2182,1184.8,2169.2,1184.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2182.9,1233.9c-15.7,0-31.9-12.1-36.1-26.9c-2-7-1.1-13.6,2.6-18.7c3.9-5.5,10.5-8.5,18.4-8.6 c0.1,0,0.1,0,0.2,0c15.7,0,31.9,12,36.1,26.9c2,7,1.1,13.6-2.6,18.7c-3.9,5.5-10.5,8.5-18.4,8.6 C2183,1233.9,2182.9,1233.9,2182.9,1233.9z M2167.9,1179.9c-0.1,0-0.1,0-0.2,0c-7.9,0-14.3,3.1-18.2,8.5 c-3.6,5-4.5,11.6-2.5,18.5c4.2,14.8,20.3,26.8,36,26.8c0.1,0,0.1,0,0.2,0c7.9,0,14.3-3.1,18.2-8.5c3.6-5,4.5-11.6,2.5-18.5 C2199.6,1191.9,2183.5,1179.9,2167.9,1179.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2154.4,
    y: 1195.7,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2151,
    y: 1227.7,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2173.1,
    y: 1225.4,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2156,
    y: 1211.9,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2206.9,
    y: 1213.2,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2179.9,
    y: 1189.8,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2189.5,
    y: 1205.6,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2175.5,
    y: 1203.6,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2156.7,1198c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2156.9,1198.4,2156.7,1198.2,2156.7,1198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2173.6,1203.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2173.8,1204,2173.6,1203.8,2173.6,1203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2178.7,1189.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 S2178.7,1190,2178.7,1189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2187.7,1206.1c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2187.8,1206.5,2187.7,1206.3,2187.7,1206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2171.7,1225c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 C2171.9,1225.4,2171.7,1225.3,2171.7,1225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2154.7,1226.7c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2154.9,1227.1,2154.7,1226.9,2154.7,1226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2205.9,1212.1c0-0.2,0.2-0.4,0.4-0.3c0.2,0,0.4,0.2,0.3,0.4s-0.2,0.4-0.4,0.3 C2206,1212.5,2205.9,1212.3,2205.9,1212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2155.8,1210.9c0-0.2,0.2-0.4,0.4-0.3c0.2,0,0.4,0.2,0.3,0.4s-0.2,0.4-0.4,0.3 C2155.9,1211.3,2155.8,1211.2,2155.8,1210.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2247,1209.5c-1.2,0-2.4-0.9-2.7-2c-0.2-0.5-0.1-1.1,0.2-1.5c0.3-0.4,0.8-0.7,1.4-0.7h0 c1.2,0,2.4,0.9,2.7,2c0.2,0.5,0.1,1.1-0.2,1.5C2248.1,1209.2,2247.6,1209.5,2247,1209.5C2247,1209.5,2247,1209.5,2247,1209.5z  M2245.9,1205.6L2245.9,1205.6c-0.5,0-1,0.2-1.2,0.6c-0.2,0.3-0.3,0.8-0.2,1.2c0.3,1,1.4,1.8,2.5,1.8h0c0.5,0,1-0.2,1.2-0.6 c0.2-0.3,0.3-0.8,0.2-1.2C2248.1,1206.4,2247,1205.6,2245.9,1205.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2248.8,1216c-5,0-10.1-3.8-11.4-8.5l0,0c-0.6-2.2-0.3-4.4,0.8-6c1.2-1.8,3.3-2.7,5.9-2.7c0,0,0,0,0.1,0 c5,0,10.1,3.8,11.4,8.5c0.6,2.2,0.3,4.4-0.8,6C2253.5,1215,2251.4,1216,2248.8,1216C2248.8,1216,2248.8,1216,2248.8,1216z  M2237.7,1207.4c1.3,4.6,6.3,8.3,11.1,8.3c0,0,0,0,0.1,0c2.4,0,4.4-0.9,5.6-2.6c1.1-1.5,1.4-3.6,0.8-5.7 c-1.3-4.6-6.3-8.3-11.1-8.3c0,0,0,0-0.1,0c-2.4,0-4.4,0.9-5.6,2.6C2237.3,1203.3,2237.1,1205.3,2237.7,1207.4L2237.7,1207.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2250.9,1223.3c-9.2,0-18.7-7.1-21.2-15.8l0,0c-1.2-4.1-0.6-8,1.5-11c2.3-3.2,6.2-5,10.8-5.1 c0,0,0.1,0,0.1,0c9.2,0,18.7,7.1,21.2,15.8c1.2,4.1,0.6,8-1.5,11C2259.5,1221.5,2255.6,1223.3,2250.9,1223.3 C2250.9,1223.3,2250.9,1223.3,2250.9,1223.3z M2242.1,1191.8C2242,1191.8,2242,1191.8,2242.1,1191.8c-4.7,0-8.4,1.8-10.7,4.9 c-2.1,2.9-2.6,6.7-1.5,10.8l0,0c2.5,8.6,11.8,15.6,20.9,15.6c0,0,0.1,0,0.1,0c4.6,0,8.3-1.8,10.6-4.9 c2.1-2.9,2.6-6.7,1.5-10.8C2260.6,1198.7,2251.2,1191.8,2242.1,1191.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2252.5,1229.2c-12.9,0-26.3-9.9-29.8-22.2l0,0c-1.6-5.8-0.9-11.2,2.1-15.4c3.2-4.5,8.6-7,15.2-7.1 c0,0,0.1,0,0.1,0c12.9,0,26.3,9.9,29.8,22.2c1.6,5.8,0.9,11.2-2.1,15.4c-3.2,4.5-8.6,7-15.2,7.1 C2252.6,1229.2,2252.5,1229.2,2252.5,1229.2z M2240.1,1184.8c0,0-0.1,0-0.1,0c-6.5,0-11.8,2.5-15,7c-2.9,4.1-3.7,9.5-2.1,15.2 l0,0c3.5,12.1,16.7,22,29.5,22c0,0,0.1,0,0.1,0c6.5,0,11.8-2.5,15-7c2.9-4.1,3.7-9.5,2.1-15.2 C2266.2,1194.6,2253,1184.8,2240.1,1184.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2253.8,1233.9c-15.7,0-31.9-12.1-36.1-26.9c-2-7-1.1-13.6,2.6-18.7c3.9-5.5,10.4-8.5,18.4-8.6 c0.1,0,0.1,0,0.2,0c15.7,0,31.9,12,36.1,26.9c2,7,1.1,13.6-2.6,18.7c-3.9,5.5-10.5,8.5-18.4,8.6 C2253.9,1233.9,2253.9,1233.9,2253.8,1233.9z M2238.8,1179.9c-0.1,0-0.1,0-0.2,0c-7.9,0-14.3,3.1-18.2,8.5 c-3.6,5-4.5,11.6-2.5,18.5c4.2,14.8,20.3,26.8,36,26.8c0.1,0,0.1,0,0.2,0c7.9,0,14.3-3.1,18.2-8.5c3.6-5,4.5-11.6,2.5-18.5 C2270.5,1191.9,2254.4,1179.9,2238.8,1179.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2225.3,
    y: 1195.7,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2221.9,
    y: 1227.7,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2244,
    y: 1225.4,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2227,
    y: 1211.9,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2277.8,
    y: 1213.2,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2250.8,
    y: 1189.8,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2260.5,
    y: 1205.6,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2246.4,
    y: 1203.6,
    className: "st17",
    width: 3.4,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2227.7,1198c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2227.8,1198.4,2227.7,1198.2,2227.7,1198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2244.5,1203.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2244.7,1204,2244.5,1203.8,2244.5,1203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2249.6,1189.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 C2249.8,1190.2,2249.6,1190,2249.6,1189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2258.6,1206.1c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2258.8,1206.5,2258.6,1206.3,2258.6,1206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2242.6,1225c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 S2242.6,1225.3,2242.6,1225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2225.7,1226.7c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4 C2225.8,1227.1,2225.7,1226.9,2225.7,1226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2276.8,1212.1c0-0.2,0.2-0.4,0.4-0.3c0.2,0,0.4,0.2,0.3,0.4c0,0.2-0.2,0.4-0.4,0.3 C2276.9,1212.5,2276.8,1212.3,2276.8,1212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2226.7,1210.9c0-0.2,0.2-0.4,0.4-0.3s0.4,0.2,0.3,0.4c0,0.2-0.2,0.4-0.4,0.3 C2226.8,1211.3,2226.7,1211.2,2226.7,1210.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2277.3,1120.9l4.3-17.4c0,0,0,0-2.3,0c-0.1,0-0.3,0-0.5,0.1c-3,1.4-12.4,12.9-13.3,13.8 c-0.8,0.8-7.6,2.6-10.1,3.2c-1.9,0-4,0-6.2,0c0.7-1.6,1.5-3.2,1.5-3.2s-0.6,0-1,0.2c-0.1,0.1-0.3,0.1-0.3,0.3l-2.6,2.7 c-7.8,0-16.5,0-24.3,0c-11.7,0-21.1,0.1-21.1,0.1c-5.9,0.1-9.1,1.7-10.6,2.8c-0.4,0.3-0.7,0.5-0.9,0.7c0,0,0,0,0,0 c-0.7,0.6-3.4,1.1-4,2.7c-0.6,1.6,6.6,3.5,10,3.9c1.2,0.1,7.2,0.2,15.1,0.2c2.1,0,4.3,0,6.6,0v1.5c0,0,0.2,0.1,0.7,0.2 c0.8,0.2,2.1,0.5,4.1,0.4c3.3-0.1,5.3-0.8,5.3-0.8v-0.5c0.5-0.1,1.4-0.3,2-0.6c0.2-0.1,0.3-0.2,0.4-0.3c10.8,0,20.6-0.1,23.2-0.1 c4.7,0,15.2-2.9,21-4.7l0,0l0,0c1.6-0.5,2.9-0.9,3.6-1.1c0.2-0.1,0.3-0.1,0.4-0.1c0.3-0.1,0.5-0.2,0.6-0.4 c0.5-0.5,0.5-1.3,0.4-1.9l3.4-2C2281.1,1120.4,2279.2,1120.6,2277.3,1120.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2820.4,805.6c0,0,90.6,97.7,94.9,134.5c4.3,36.8-43.4,94.2-43.4,94.2L2820.4,805.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2779.4,1817.9c0,0-3.2,51.8-12.8,52.5c-1.3,0.1-48.9,0-48.9,0l-60.8-0.5c0,0,0.4-15.2,18.2-18.4 c17.8-3.2,47.6-16.1,58.4-40.5C2744.9,1785.4,2779.4,1817.9,2779.4,1817.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2914.8,1818.2c0,0-3.2,51.8-12.8,52.5c-1.3,0.1-48.9,0-48.9,0l-60.8-0.5c0,0,0.4-15.2,18.2-18.4 c17.8-3.2,47.6-16.1,58.4-40.5C2880.3,1785.7,2914.8,1818.2,2914.8,1818.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2713.3,1260.8c0,0,15.7,105.8,74.6,293.6s66.8,269.1,66.8,269.1l63.6-1.7c0,0,1-205.1-26.2-299.6 c-27.1-94.4-5.2-340.3-5.2-340.3L2713.3,1260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2682.5,1187.3c0,0-2.6,159.3,23.5,355s16.9,278.7,16.9,278.7l63.5,2.3c0,0,38.4-195.6,27.7-293.6 c-10.7-97.9,52.7-335.9,52.7-335.9L2682.5,1187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2806.2,814.7l-33.9,23l-48.9-9.6c0.7-4.1,3.9-21.1,6.9-36.5c0.2-0.9,0.4-1.8,0.5-2.7 c2.5-13.1,4.7-24.4,4.7-24.4l45.7-20.8l17-7.8c0,0.3-1.3,14.5-1.5,16.6C2793.6,789.6,2806.2,814.7,2806.2,814.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2736,802.9c1-0.4,58.9-18.1,65.2-15.9c6.3,2.2,10,14.8,10,14.8l-94.8,22.1 C2716.4,824,2723.9,808.2,2736,802.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2891.2,1207.5c-9.9,46.6-173.4,51.7-215.4,9.3c-4.8-4.8-5-27.3-3.1-57.5c3.7-59.1,15.2-147.9,15.7-193.3 c0.3-21.9,3.2-44.3,7.1-64.7c8.3-43.4,20.9-77.4,20.9-77.4s79.9-26.7,94.8-22C2883.1,824,2901.1,1160.9,2891.2,1207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M2672.7,1159.3c3.7-59.1,15.2-147.9,15.7-193.3c0.3-21.9,3.2-44.3,7.1-64.7l48-8.7 C2743.5,892.6,2790.1,1092.1,2672.7,1159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2698.8,1077c0,0,3.3,8.1-3.6,13.6s-11.4,14.3-9.8,20.8s16.6,17,21.8,15.4c5.2-1.7,15.9-10.2,14.7-13.6 c-1.1-3.4,7.2-29.9-5.5-40.2C2703.8,1062.8,2698.8,1077,2698.8,1077z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2753.1,812.1c0,0-46.8,9-84.3,66.1c-37.4,57.1-62.1,99.5-55.2,120.2s69.3,92.2,80.1,92.3 c10.8,0,28.3-8.1,29.3-26.5c0,0-44-68.8-35.3-79.1c3.7-4.4,57.4-49.5,65-29C2765.3,989.8,2753.1,812.1,2753.1,812.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M2793.4,753.2c-10.1,17.6-47.5,32.8-63.1,38.4c0.2-0.9,0.4-1.8,0.5-2.7c2.5-13.1,4.7-24.4,4.7-24.4 l45.7-20.8C2791.4,743.6,2797.6,746,2793.4,753.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2718.4,761.6c0,0,73.5,24,87.2-23.8c13.7-47.8,32.4-76.9-14-94.3c-46.4-17.4-60.7-1.9-69,12.9 C2714.3,671.2,2699.6,754.2,2718.4,761.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M2725.5,651.8c0,0,4.6,55.7,15.7,53.3c11.1-2.4,21.1-4.2,19.5,12.6c-1.7,16.8-17.1,36.1,17.1,39.2 s83.4-88.4,74.1-105.7C2824.8,601.1,2686.5,590.7,2725.5,651.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M707.9,1811.5c0,0-3.4,55.1-13.7,55.9c-1.4,0.1-52,0-52,0l-64.7-0.5c0,0,0.5-16.2,19.4-19.6 c18.9-3.4,50.6-17.1,62.1-43.1C671.1,1776.9,707.9,1811.5,707.9,1811.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M893,1358.2c2.5,2.2,68.3,76.4,63,133.4c-1.6,16.7-15.4,29.3-31.6,29.3h-80.2c0,0-81.9,15.2-83.8,33.6 c-1.9,18.4-18.7,117.6-51.9,258.4c0,0-24.5,8.8-39.3,2.5c-19.6-8.3-22.5-17-22.5-17s19.8-315.5,35.4-337.7 c15.6-22.2,176.6-88.2,228.7-94.8C962.8,1359.3,893,1358.2,893,1358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M427.7,1279.5c0,0-46.6-11.3-58.5,0c-11.9,11.3-15.7,27.6-15.7,27.6h74.2V1279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M594.6,1811.5c0,0-3.4,55.1-13.7,55.9c-1.4,0.1-52,0-52,0l-64.7-0.5c0,0,0.5-16.2,19.4-19.6 c18.9-3.4,50.6-17.1,62.1-43.1C557.8,1776.9,594.6,1811.5,594.6,1811.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M953.9,1358.2c1.9,1.6,16.1,41.5,25.6,86.8c8.2,39-20.3,75.9-58.7,75.9H734.2c0,0-81.9,15.2-83.8,33.6 c-1.9,18.4-18.7,117.6-51.9,258.4c0,0-24.5,6.7-43.7-1.8c-10.2-4.5-18.2-15.4-18.2-15.4s20-312.8,35.6-335.1 c15.6-22.2,176.6-88.2,228.7-94.8C852.9,1359.3,953.9,1358.2,953.9,1358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M850.4,1076.1l-28.9,28.8l-49.2,0c-0.1-4.1,0.1-21.3,0.3-36.8c0-0.9,0-1.8,0-2.7c0-3.5,0.1-6.8,0.1-9.8 c0.1-8.6,0.2-14.8,0.2-14.8l12.6-9l28.1-20l15.2-10.8c0,0.3,1.3,14.4,1.4,16.4C833.7,1054.1,850.4,1076.1,850.4,1076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M778.9,1070.9c0.9-0.4,54.1-25.2,60.4-23.1c6.2,2.1,14,21.9,14,21.9l-93.7,22 C759.6,1091.7,767,1076.1,778.9,1070.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1009.1,1236.7c-10.1-65-52.9-113.6-71.3-131.9c-12.3-19.2-84.5-35.1-84.5-35.1s-59.9,14.1-93.7,22 c0,0-52.8,6-82.6,57.2c-18.4,31.7-71.2,104.1-105.8,106.4c-34.6,2.3-143.4,24.2-143.4,24.2v27.8l165.9,4.7c2,0.1,4-0.1,6-0.5 c14.3-2.8,75.5-15.4,105.9-31.9c4.9,81.5,10.6,205.9,38,225.6c28.9,20.9,232.5,23.7,254-8.2c11-16.3-2.5-112.8-19.4-205.9 C999.1,1280.8,1013.3,1264,1009.1,1236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M821.1,1028.9l-2.5,1.6c0,0-23.1,17.3-45.7,25.1c0.1-8.6,0.2-14.8,0.2-14.8l12.6-9L821.1,1028.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M755.8,1041.3c0,0,75.7,9.3,80.5-39.8c4.9-49.1,17.9-80.9-30.2-89c-48.1-8-59.4,9.7-64.8,25.7 C735.8,954.2,736.2,1037.6,755.8,1041.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M743.2,933.2c0,0,14.3,53.2,24.6,48.8s19.8-8.1,21.2,8.5c1.4,16.6-10.2,38.4,23.5,34.8 c33.7-3.6,65.4-101.8,53.3-116.9C830.8,865,694.6,881.3,743.2,933.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1740.7,1811.5c0,0-3.4,55.1-13.7,55.9c-1.4,0.1-52,0-52,0l-64.7-0.5c0,0,0.5-16.2,19.4-19.6 c18.9-3.4,50.6-17.1,62.1-43.1C1703.9,1776.9,1740.7,1811.5,1740.7,1811.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1925.8,1358.2c2.5,2.2,68.3,76.4,63,133.4c-1.6,16.7-15.4,29.3-31.6,29.3h-80.2c0,0-81.9,15.2-83.8,33.6 c-1.9,18.4-18.7,117.6-51.9,258.4c0,0-24.5,8.8-39.3,2.5c-19.6-8.3-22.5-17-22.5-17s19.8-315.5,35.4-337.7 c15.6-22.2,176.6-88.2,228.7-94.8C1995.6,1359.3,1925.8,1358.2,1925.8,1358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1460.5,1279.5c0,0-46.6-11.3-58.5,0c-11.9,11.3-15.7,27.6-15.7,27.6h74.2V1279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1627.4,1811.5c0,0-3.4,55.1-13.7,55.9c-1.4,0.1-52,0-52,0l-64.7-0.5c0,0,0.5-16.2,19.4-19.6 c18.9-3.4,50.6-17.1,62.1-43.1C1590.6,1776.9,1627.4,1811.5,1627.4,1811.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1986.7,1358.2c1.9,1.6,16.1,41.5,25.6,86.8c8.2,39-20.3,75.9-58.7,75.9H1767c0,0-81.9,15.2-83.8,33.6 c-1.9,18.4-18.7,117.6-51.9,258.4c0,0-24.5,6.7-43.7-1.8c-10.2-4.5-18.2-15.4-18.2-15.4s20-312.8,35.6-335.1 c15.6-22.2,176.6-88.2,228.7-94.8C1885.7,1359.3,1986.7,1358.2,1986.7,1358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1883.2,1076.1l-28.9,28.8l-49.2,0c-0.1-4.1,0.1-21.3,0.3-36.8c0-0.9,0-1.8,0-2.7c0-3.5,0.1-6.8,0.1-9.8 c0.1-8.6,0.2-14.8,0.2-14.8l12.6-9l28.1-20l15.2-10.8c0,0.3,1.3,14.4,1.4,16.4C1866.5,1054.1,1883.2,1076.1,1883.2,1076.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1811.7,1070.9c0.9-0.4,54.1-25.2,60.4-23.1c6.2,2.1,14,21.9,14,21.9l-93.7,22 C1792.4,1091.7,1799.7,1076.1,1811.7,1070.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2041.8,1236.7c-10.1-65-52.9-113.6-71.3-131.9c-12.3-19.2-84.5-35.1-84.5-35.1s-59.9,14.1-93.7,22 c0,0-52.8,6-82.6,57.2c-18.4,31.7-71.2,104.1-105.8,106.4c-34.6,2.2-143.4,24.2-143.4,24.2v27.8l165.9,4.7c2,0.1,4-0.1,6-0.5 c14.3-2.8,75.5-15.4,105.9-31.9c4.9,81.5,10.6,205.9,38,225.6c28.9,20.9,232.5,23.7,254-8.2c11-16.3-2.5-112.8-19.4-205.9 C2031.9,1280.8,2046.1,1264,2041.8,1236.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1853.8,1028.9l-2.5,1.6c0,0-23.1,17.3-45.7,25.1c0.1-8.6,0.2-14.8,0.2-14.8l12.6-9L1853.8,1028.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1788.6,1041.3c0,0,75.7,9.3,80.5-39.8c4.9-49.1,17.9-80.9-30.2-89c-48.1-8-59.4,9.7-64.8,25.7 C1768.6,954.2,1769,1037.6,1788.6,1041.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1776,933.2c0,0,14.3,53.2,24.6,48.8s19.8-8.1,21.2,8.5c1.4,16.6-10.2,38.4,23.5,34.8 c33.7-3.6,65.4-101.8,53.3-116.9C1863.6,865,1727.4,881.3,1776,933.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M689.7,1531.4H1064c14.2,0,25.7-12,25.7-26.8v-17.4h-400L689.7,1531.4L689.7,1531.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M644.8,1531.4H928c10.5,0,19-8.9,19-19.8v-4.6c0-10.9-8.5-19.8-19-19.8H644.8c-10.5,0-19,8.9-19,19.8v4.6 C625.8,1522.6,634.3,1531.4,644.8,1531.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "880.5,1850.9 904.7,1850.9 911.5,1531.4 874.6,1531.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "775.6,1850.9 1010.4,1850.9 1010.4,1828.8 890.8,1817.6 775.6,1828.8  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 1013.9,
    cy: 1847.4,
    rx: 19.3,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 779.1,
    cy: 1847.4,
    rx: 19.3,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M784,1552.4h218c11.1,0,20.2-9.4,20.2-21l0,0H763.9l0,0C763.9,1543,772.9,1552.4,784,1552.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1052.7,1531.4c10.2,0,18.4-8.6,18.4-19.1v-294.1c0-55.1-34.7-99.8-77.4-99.8H818.6 c-42.8,0-77.4,44.7-77.4,99.8v313.3H1052.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1056.2,1531.4c18.5,0,33.5-15.6,33.5-34.9v-278.4c0-55.1-34.7-99.8-77.4-99.8H837.2 c-42.8,0-77.4,44.7-77.4,99.8v313.3L1056.2,1531.4L1056.2,1531.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1298.4,
    y: 1437.8,
    className: "st33",
    width: 135.8,
    height: 434.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1109.8,
    y: 1437.8,
    className: "st4",
    width: 199.7,
    height: 434.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.5,
    y: 1516.7,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.5,
    y: 1609.6,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.5,
    y: 1702.4,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.5,
    y: 1795.3,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1317.9,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1319.4,1453.1,1317.9,1451.6,1317.9,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1335.9,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1337.3,1453.1,1335.9,1451.6,1335.9,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1353.8,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1355.3,1453.1,1353.8,1451.6,1353.8,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1371.8,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1373.3,1453.1,1371.8,1451.6,1371.8,1449.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 1321.2,
    cy: 1630.9,
    rx: 3.3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 1339.2,
    cy: 1630.9,
    rx: 3.3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1353.8,1630.9c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1355.3,1634.3,1353.8,1632.8,1353.8,1630.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 1375.1,
    cy: 1630.9,
    rx: 3.3,
    ry: 3.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1317.9,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1319.4,1738.8,1317.9,1737.3,1317.9,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1335.9,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1337.3,1738.8,1335.9,1737.3,1335.9,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1353.8,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1355.3,1738.8,1353.8,1737.3,1353.8,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1371.8,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C1373.3,1738.8,1371.8,1737.3,1371.8,1735.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1126.7,
    y: 1466,
    className: "st16",
    width: 163.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126.7,
    y: 1479.2,
    className: "st16",
    width: 163.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126.7,
    y: 1493.9,
    className: "st16",
    width: 163.7,
    height: 4.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2288.3,
    y: 1437.8,
    className: "st33",
    width: 135.8,
    height: 434.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2099.7,
    y: 1437.8,
    className: "st4",
    width: 199.7,
    height: 434.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2299.5,
    y: 1516.7,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2299.5,
    y: 1609.6,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2299.5,
    y: 1702.4,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2299.5,
    y: 1795.3,
    className: "st4",
    width: 124.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2307.8,1449.7c0-1.9,1.5-3.4,3.3-3.4s3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4S2307.8,1451.6,2307.8,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2325.8,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2327.3,1453.1,2325.8,1451.6,2325.8,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2343.8,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2345.2,1453.1,2343.8,1451.6,2343.8,1449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2361.7,1449.7c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2363.2,1453.1,2361.7,1451.6,2361.7,1449.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 2311.1,
    cy: 1630.9,
    rx: 3.3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 2329.1,
    cy: 1630.9,
    rx: 3.3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2343.8,1630.9c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2345.2,1634.3,2343.8,1632.8,2343.8,1630.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2361.7,1630.9c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2363.2,1634.3,2361.7,1632.8,2361.7,1630.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2307.8,1735.4c0-1.9,1.5-3.4,3.3-3.4s3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4S2307.8,1737.3,2307.8,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2325.8,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2327.3,1738.8,2325.8,1737.3,2325.8,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2343.8,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2345.2,1738.8,2343.8,1737.3,2343.8,1735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2361.7,1735.4c0-1.9,1.5-3.4,3.3-3.4c1.8,0,3.3,1.5,3.3,3.4c0,1.9-1.5,3.4-3.3,3.4 C2363.2,1738.8,2361.7,1737.3,2361.7,1735.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2116.7,
    y: 1466,
    className: "st16",
    width: 163.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2116.7,
    y: 1479.2,
    className: "st16",
    width: 163.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2116.7,
    y: 1493.9,
    className: "st16",
    width: 163.7,
    height: 4.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1722.4,1531.4h374.3c14.2,0,25.7-12,25.7-26.8v-17.4h-400V1531.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1677.6,1531.4h283.2c10.5,0,19-8.9,19-19.8v-4.6c0-10.9-8.5-19.8-19-19.8h-283.2c-10.5,0-19,8.9-19,19.8 v4.6C1658.5,1522.6,1667.1,1531.4,1677.6,1531.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1913.3,1850.9 1937.5,1850.9 1944.2,1531.4 1907.4,1531.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1808.4,1850.9 2043.2,1850.9 2043.2,1828.8 1923.5,1817.6 1808.4,1828.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2066,1847.4c0-11.1-8.6-20.1-19.3-20.1c-10.7,0-19.3,9-19.3,20.1c0,11.1,8.6,20.1,19.3,20.1 C2057.4,1867.5,2066,1858.5,2066,1847.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 1811.9,
    cy: 1847.4,
    rx: 19.3,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1816.8,1552.4h218c11.1,0,20.2-9.4,20.2-21l0,0h-258.3l0,0C1796.7,1543,1805.7,1552.4,1816.8,1552.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2085.5,1531.4c10.2,0,18.4-8.6,18.4-19.1v-294.1c0-55.1-34.7-99.8-77.4-99.8h-175.1 c-42.8,0-77.4,44.7-77.4,99.8v313.3H2085.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2089,1531.4c18.5,0,33.5-15.6,33.5-34.9v-278.4c0-55.1-34.7-99.8-77.4-99.8H1870 c-42.8,0-77.4,44.7-77.4,99.8v313.3L2089,1531.4L2089,1531.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M3229.9,1876.9H5.1c-2.1,0-3.8-1.8-3.8-3.9v-1.6c0-2.2,1.7-3.9,3.8-3.9h3224.8c2.1,0,3.8,1.8,3.8,3.9v1.6 C3233.7,1875.2,3232,1876.9,3229.9,1876.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplanemoM2);
export default __webpack_public_path__ + "static/media/aeroplanemo_m2.3f20073ecb77093ff8591ca03a94bd0a.svg";
export { ForwardRef as ReactComponent };